class AnimateScroll extends HTMLElement {
  constructor () {
    super()

    this.querySelectorAll('a').forEach(link => {
      const href = link.getAttribute('href')

      if (href[0] == '#') link.addEventListener('click', (event) => {
        event.preventDefault()
        this.onAnimateScroll(href)
      })
    })
  }

  onAnimateScroll(href) {
    const targetElement = document.querySelector(href)
    if (!targetElement) return

    const headerHeight = document.querySelector('#shopify-section-header')?.offsetHeight
    const scrollPos = targetElement.offsetTop - headerHeight
    window.scrollTo({
      top: scrollPos,
      behavior: 'smooth'
    });
  }
}

window.customElements.define('animate-scroll', AnimateScroll)
